// AI助手模块类型定义
export const MODULE_TYPES = {
  GENERAL: 'GENERAL',
  MEDICAL: 'MEDICAL',
  SALES: 'SALES',
  OFFICE: 'OFFICE',
  MAINTENANCE: 'MAINTENANCE'
}

// 验证模块类型
export const validateModuleType = (value) => {
  return Object.values(MODULE_TYPES).includes(value)
}

// 获取模块类型显示名称
export const getModuleTypeName = (type) => {
  const nameMap = {
    GENERAL: '通用',
    MEDICAL: '医疗',
    SALES: '销售',
    OFFICE: '办公',
    MAINTENANCE: '维修'
  }
  return nameMap[type] || type
} 